module.exports = __webpack_public_path__ + "img/contact.3195e4e5.jpg";